export enum AppEnvUrlPart {
  Development = 'dev',
  Hook = 'hook',
  Stage = 'stage',
}
